// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"5c532356","186":"25e45085","272":"08185da8","372":"1525d3b2","377":"be636090","738":"f621437c","841":"ace81c72","851":"df55df45","856":"da4b1885"}[chunkId] + ".chunk.js";
};